import { invalidateCachedReads, registerCachedReadRoot } from "./queryClient";

export const POSTMORTEM_READ_STALE_TIME = 60 * 1000;

let lastPathname = null;
// Every page navigation starts from fresh data, as it did before caching; only repeats within one page are shared.
const resetCachedReadsOnNavigation = () => {
  const { pathname } = window.location;
  if (lastPathname !== null && pathname !== lastPathname) invalidateCachedReads();
  lastPathname = pathname;
};

// Components that mount together on the same page share one request, and remounts reuse the cached result.
export const cachedRequest = (queryClient, queryKey, requestFn, options = {}) => {
  registerCachedReadRoot(queryKey[0]);
  resetCachedReadsOnNavigation();
  return queryClient.fetchQuery(queryKey, requestFn, {
    staleTime: POSTMORTEM_READ_STALE_TIME,
    retry: false,
    ...options,
  });
};
